var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 77,
    viewBox: "0 0 58 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5672 5.45689L15.3536 13.2846L22.234 8.66335C24.9753 11.0593 27.5905 14.4667 29.4975 19.0413L25.3724 25.9461L31.0718 23.5746C32.093 27.1258 32.8084 31.3237 32.9964 36.1408C32.9964 36.1408 24.6432 32.7033 16.6539 26.3438L20.0461 18.0922L12.888 23.1354C7.03203 17.7264 2.16211 10.7282 2.06157 2.49803C2.06157 2.49803 9.74139 1.40035 17.5672 5.45689Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6889 58.5972L28.2721 67.7379L21.5117 65.0696L19.4306 44.7227L10.1523 60.4587L6.28727 58.95L5.15041 48.1939L0.178121 56.4769L-18.6897 48.8763C-18.6897 48.8763 -5.99692 29.2286 18.0125 37.1274C42.036 44.9138 48.8317 63.5653 48.8436 76.1215L34.9075 70.5048L33.6889 58.5972Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsLeft);
export default __webpack_public_path__ + "static/media/palmLeafsLeft.6693fcff42eda1e3b808f0c0dc7a236f.svg";
export { ForwardRef as ReactComponent };